"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get HANDLE_PRIORITY_ERROR () {
        return HANDLE_PRIORITY_ERROR;
    },
    get TelemetryHandlerService () {
        return TelemetryHandlerService;
    }
});
const _common = require("@nestjs/common");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _eventemitterinterface = require("~/modules/event-emitter/event-emitter.interface");
const _telemetryservice = require("~/services/telemetry.service");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
const HANDLE_PRIORITY_ERROR = '__nc_handlePriorityError';
let TelemetryHandlerService = class TelemetryHandlerService {
    static sendPriorityError(context, param) {
        _Noco.default.eventEmitter.emit(HANDLE_PRIORITY_ERROR, _extends({
            context
        }, param));
    }
    async handlePriorityError(context, param) {
        var _context_user, _context_user1;
        this.telemetryService.sendSystemEvent({
            event_type: 'priority_error',
            error_trigger: param.trigger,
            error_type: param.error_type,
            message: param.message,
            error_details: param.error_details,
            affected_resources: [
                (_context_user = context.user) == null ? void 0 : _context_user.email,
                (_context_user1 = context.user) == null ? void 0 : _context_user1.id,
                context.base_id,
                context.workspace_id
            ]
        });
    }
    onModuleInit() {
        this.unsubscribe = this.eventEmitter.on(HANDLE_PRIORITY_ERROR, async (arg)=>{
            try {
                const { context } = arg, rest = _object_without_properties_loose(arg, [
                    "context"
                ]);
                return this.handlePriorityError(context, rest);
            } catch (e) {
                this.logger.error({
                    error: e,
                    details: 'Error while handle priority error on telemetry service'
                });
            }
        });
    }
    onModuleDestroy() {
        this.unsubscribe == null ? void 0 : this.unsubscribe.call(this);
    }
    constructor(eventEmitter, telemetryService){
        this.eventEmitter = eventEmitter;
        this.telemetryService = telemetryService;
        this.logger = new _common.Logger(TelemetryHandlerService.name);
    }
};
TelemetryHandlerService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_param(0, (0, _common.Inject)('IEventEmitter')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _eventemitterinterface.IEventEmitter === "undefined" ? Object : _eventemitterinterface.IEventEmitter,
        typeof _telemetryservice.TelemetryService === "undefined" ? Object : _telemetryservice.TelemetryService
    ])
], TelemetryHandlerService);
